export default __webpack_public_path__ + "static/media/High Priest's Ring of Intelligence.875db237.jpg";